/**
 * Creates a macrotask to yield execution back to the main thread, providing a faster alternative to `setTimeout` while
 * still allowing a brief pause in execution. In a browser environment, the minimum time for `setTimeout` is 4-5ms, even
 * when set to 0, whereas this method executes immediately.
 */
export async function yieldExecution() {
    return new Promise((resolve) => {
        const mc = new MessageChannel();
        mc.port1.onmessage = () => {
            mc.port1.close();
            mc.port2.close();
            resolve();
        };
        mc.port2.postMessage(1);
    });
}
